import { render, staticRenderFns } from "./ShiftSettings.vue?vue&type=template&id=703d2dca&"
import script from "./ShiftSettings.vue?vue&type=script&lang=js&"
export * from "./ShiftSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports